const emojidata = [
  {
    id: 1,
    emoji: "😀",
    name: "Grinning",
    info:
      "The happy smiling face is one of the most common emojis and universally applicable: you just want to say hello, express joy or excitement about something or brighten up a short text.",
  },
  {
    id: 2,
    emoji: "😂",
    name: "LOL",
    info:
      "I am laughing to hard that I can hardly keep myself on my chair! Something is so incredibly funny that you cry laughing. Gets the giggles and can hardly contain himself. ",
  },
  {
    id: 3,
    emoji: "😅",
    name: "Sweaty Smile",
    info:
      "Relief that a tight situation went well or was coped with positively, e.g. an important appointment. A difficult event is imminent and you are already nervous.",
  },
  {
    id: 4,
    emoji: "😇",
    name: "Smiling Face with Halo",
    info:
      "Would like to express its (possibly pretended) innocence. The angelic face can also be used humorously for rather not so good deeds or behaviors.",
  },
  {
    id: 5,
    emoji: "🙃",
    name: "Upside-Down Face",
    info:
      "Don't take me seriously! The message is either ambiguous, ironic or joking. Person plays the fool and horses around, or in response to a joke.",
  },
  {
    id: 6,
    emoji: "😉",
    name: "Winking Face",
    info:
      "Smiley blinks mischievously with one eye. Expression of humor, has been pulling a practical joke, is flirting with you or has an ulterior motive. Regard it as humorous.",
  },
  {
    id: 7,
    emoji: "😌",
    name: "Relieved Face",
    info:
      "Everything went well! Relieved smiley face. Is happy that something unpleasant is over without having caused any harm. Relaxed, thankful and free of worries.",
  },
  {
    id: 8,
    emoji: "😛",
    name: "Face With Stuck-Out Tongue",
    info:
      "Horseplay with friends, weakening an ironic remark and making sure that the other does not take seriously what has been said. Making fun of others: I knew you'd screw it up.	",
  },
  {
    id: 9,
    emoji: "🤪",
    name: "Crazy Face",
    info:
      "Something is insanely funny. The mood is exuberant - you are totally silly and crazy. Totally freaking out with enthusiasm or joy. Maybe someone has even told an indecent joke🤪",
  },
  {
    id: 10,
    emoji: "🤨",
    name: "Raised Eyebrow",
    info:
      "With the questioning look on the face, resembles the actor “The Rock“ (Dwayne Johnson). Can be used to express skepticism, disbelief or disapproval.",
  },
  {
    id: 10,
    emoji: "🧐",
    name: "Monocle Face",
    info:
      "Something seems suspicious! The smiley makes a warning look around. The “upper-class“ version of the pondering smiley.",
  },
  {
    id: 12,
    emoji: "🤓",
    name: "Nerd Face",
    info:
      "Huge glasses, awkward smile and buck teeth. Used humorously or ironically for nerds or to express how smart you are. Stereotype of a nerd..",
  },
  {
    id: 13,
    emoji: "😎",
    name: "Cool Face",
    info:
      "I'm the king of the world! Mr. Cool Smiley with sunglasses. Is totally self-assured and relaxed. Also a symbol for sun, summer holidays, and holidays on the beach.",
  },
  {
    id: 14,
    emoji: "🥳",
    name: "Party Face",
    info:
      "That was a wild party or “Let's celebrate“. No matter what joyful event is in view, it will be celebrated appropriately. May also stand for the carnival season.",
  },
];
export default emojidata;
